import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { createCustomElement } from '@angular/elements';
import { AppModule } from './app/app.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then((moduleRef) => {
  const AppElement = createCustomElement(AppComponent, { injector: moduleRef.injector });
  customElements.define('mfe-abertura-conta-agro', AppElement);
}).catch((err?: string) => { console.log(err); throw new Error(err); });
